import * as Yup from 'yup';

import MESSAGES from 'validations/constants/messages';

export const appMappingSchema = Yup
  .object()
  .shape({
    client_type: Yup
      .number()
      .integer()
      .positive(),
    map: Yup
      .object()
      .default({}),
  });

export const appMappingFormSchema = Yup
  .object()
  .shape({
    mapping: Yup
      .array()
      .of(appMappingSchema)
      .default([])
      .required(MESSAGES.REQUIRED),
    type: Yup
      .string()
      .required(MESSAGES.REQUIRED)
      .trim()
      .lowercase(),
  });
